import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AsyncPipe, NgIf, NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ContextResponse } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { DynamicContentTargets, WithDynamicContent } from '@woolworthsnz/dynamic-content';
import { FeatureService, WithPageMeta } from '@woolworthsnz/styleguide';
import { HeroCarouselComponent } from '../../components/hero-carousel/hero-carousel.component';
import EnabledFeaturesEnum = ContextResponse.EnabledFeaturesEnum;

@WithPageMeta()
@WithDynamicContent({
	target: '/',
	dynamicContentTarget: DynamicContentTargets.dynamicContentBottomPanel,
})
@Component({
	selector: 'wnz-home',
	template: `
		<wnz-hero-carousel *ngIf="isHomePageHeroCarouselEnabled$ | async" class="hero-carousel"></wnz-hero-carousel>
		<section id="dynamic-content-bottom-panel" class="dynamic-content-canvas"></section>
		<router-outlet name="info-modal"></router-outlet>
	`,
	styleUrls: ['./home.page.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [AsyncPipe, NgIf, NgClass, RouterOutlet, HeroCarouselComponent],
})
export class HomePage implements OnInit {
	isHomePageHeroCarouselEnabled$: Observable<boolean>;

	constructor(private featureService: FeatureService) {}

	ngOnInit(): void {
		this.isHomePageHeroCarouselEnabled$ = this.featureService.isEnabled(EnabledFeaturesEnum.HomePageHeroCarousel);
	}
}
